mutation RestoreTranslations($ids: [ID!]!) {
  restoreTranslations(ids: $ids) {
    id
    deletedAt
  }
}
